import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'nova-match-category-candidate',
    templateUrl: './match-category-candidate.component.html',
    styleUrls: ['./match-category-candidate.component.scss'],
    standalone: true,
    imports: [CommonModule]
})
export class MatchCategoryCandidateComponent {
    @Input() candidateName: string | undefined;
    @Input() matchCategory: string | undefined;
    @Input() dataQaId?: string = 'match-category-candidate';
}
